$(document).ready( function() {
    if($('body.single-product').length > 0) {

        if( $('.image-column .variation-image').length > 0) {
            $('.variations select').on('change', updateImageVariations);
            updateImageVariations();
        }
    
        $(document).on('change', '#pa_katisyys, input[data-attribute="pa_katisyys"]', mirrorProductImage);
        mirrorProductImage();

        var chosen_form = [];

        $(document).on('change', '.variations select', function() {
            mittatiedot_form();
        })
        mittatiedot_form();

        function mittatiedot_form() {
            if (typeof (productData) === 'object') {

                productData.forEach( (productData, index) => {
                    if(productData.ehdollisuus) {
                      if(productData.logiikka == 'on') {
                        $(document).on('change', '#pa_' + productData.ominaisuus, function() {
                          const value = $('#pa_' + productData.ominaisuus).val()
                          if ( productData.ominaisuuden_arvo == value ) {
                            updateForm(index)
                          }
                        })
                        const value = $('#pa_' + productData.ominaisuus).val()
                        if ( productData.ominaisuuden_arvo == value ) {
                          updateForm(index)
                        }
                      } else {
                        $(document).on('change', '#pa_' + productData.ominaisuus, function() {
                          const value = $('#pa_' + productData.ominaisuus).val()
                          if(value.length) {
                            if ( productData.ominaisuuden_arvo !== value ) {
                              updateForm(index)
                            }
                          }
                        })
                        const value = $('#pa_' + productData.ominaisuus).val()
                        if(value.length) {
                          if ( productData.ominaisuuden_arvo !== value ) {
                            updateForm(index)
                          }
                        }
                      }
                    } else {
                      updateForm(index)
                    }
                })
            }
        }

        function updateForm(index) {
            let othersIndex = 0;
            productData.forEach( (form, i) => {
                if(form.ehdollisuus) {
                    if(i > othersIndex && $('#pa_' + form.ominaisuus).val() && productData[index].ominaisuus !== form.ominaisuus) {
                        othersIndex = i
                    }
                }
            })
            if (othersIndex > index) return

            chosen_form = productData[index]
        }
    
        //modeler changes
        $(document).on('keyup', '#levy-leveys', function() {
            update_width_modelers()
        })
        $(document).on('change', '#pa_kotelo', function() {
            update_width_modelers()
        })

        function update_width_modelers() {
            var value = $('#levy-leveys').val()
            if(value) {
                $('#width-modeler').show()
                if( chosen_form ) {
                    if(chosen_form.different_fabric_width) {
                        $('#width-modeler-top').show()
                        $('#width-modeler-top .size .value').text(value)
                        if(chosen_form.fabric_width_casing) {
                            if( $('#pa_kotelo').length > 0 && $('#pa_kotelo').val() !== 'ei' && $('#pa_kotelo').val() !== '' ) {
                                value = parseInt(value) + parseInt(chosen_form.fabric_width_casing)
                            } else {
                                value = parseInt(value) + parseInt(chosen_form.fabric_width)
                            }
                        } else {
                            value = parseInt(value) + parseInt(chosen_form.fabric_width)
                        }
                        if(value < 0) {
                            $('#width-modeler').hide()
                        }
                    }
                }
                $('#width-modeler .size .value').text(value)

                if($('#pa_kelautumissuunta').val() == 'edesta') {
                    $('#width-modeler').addClass('front')
                } else {
                    $('#width-modeler').removeClass('front')
                }
            } else {
                $('#width-modeler').hide()
            }
        }
    
        $(document).on('keyup', '#levy-korkeus', function() {
            const value = $(this).val()
            if(value) {
                $('#height-modeler').show()
                $('#height-modeler .size .value').text(value)
            } else {
                $('#height-modeler').hide()
            }
        })
    
        $(document).on('change', '#more-height-to-default', function() {
            const value = $('#levy-korkeus').val()
            if(value) {
                $('#height-modeler').show()
                $('#height-modeler .size .value').text(value)
            } else {
                $('#height-modeler').hide()
            }
        })
    
        $(document).on('keyup', '#levy-pituus', function() {
            const value = $(this).val()
            if(value) {
                $('#length-modeler').show()
                $('#length-modeler .size .value').text(value)
            } else {
                $('#length-modeler').hide()
            }
        })

        $(document).on('change', '#pa_kelautumissuunta', function() {
            if($(this).val() == 'edesta') {
                $('#width-modeler').addClass('front')
            } else {
                $('#width-modeler').removeClass('front')
            }
        })
    }
})

function mirrorProductImage() {
    if( $('#pa_katisyys').val() == 'vasen') {
        $('.content-columns > .image-column').addClass('mirror')
    } else {
        $('.content-columns > .image-column').removeClass('mirror')
    }
}

// This function updates which variation images are shown based on current select values.
function updateImageVariations() {

    $('.single-product .image-column .image:not(.variation-image)').hide();

    $('.image-column .variation-image').hide();

    var selectedValues = {};
    var notSelectedValues = {};

    $('.variations select').each(function() {
        var variationName = $(this).attr('id');
        var selectedValue = $(this).val();

        if( selectedValue ) {
            selectedValues[variationName] = {
                value: selectedValue,
                image: false
            };
        } else {
            notSelectedValues[variationName] = {
                image: false
            }
        }
    });

    $('.image-column .variation-image').each(function() {
        var showImage = true;
        const $img = $(this);

        //check if image has value for selected value and hide ones that have different values
        Object.keys(selectedValues).forEach(function(key) {
            var object = selectedValues[key];
            if($img.is('[data-' + key + ']')) {
                if ($img.attr('data-' + key) !== object.value) {
                    showImage = false;
                    return false;
                }
            }
        })

        if(showImage == true) {
            //show first value for not selected values
            if(Object.keys(notSelectedValues).length > 0) {
                Object.keys(notSelectedValues).forEach(function(key) {
                    var object = notSelectedValues[key];
                    if (object.image === false && $img.is('[data-' + key + ']')) {
                        $img.show();
                        notSelectedValues[key].image = true;
                    }
                });   
            }

            //show selected image
            if(Object.keys(selectedValues).length > 0) {
                Object.keys(selectedValues).forEach(function(key) {
                    var object = selectedValues[key];
                    if (/*object.image === false &&*/ $img.is('[data-' + key + ']')) {
                        if ($img.attr('data-' + key) == object.value) {
                            $img.show();
                            selectedValues[key].image = true;
                        }
                    }
                });   
            }
        }
    });
}
